export enum ContentType {
	whiteboard = 'whiteboard',
	liveDoc = 'liveDoc',
	database = 'database',
	workItem = 'workItem',
	slides = 'slides',
	dashboard = 'dashboard',
	page = 'page',
}

/**
 * Normalises the `type`/`subType` returned for finalized Confluence content into
 * a {@link ContentType}. Shared so the preview card, title dropdown and finalize
 * dialog resolve content types identically.
 */
export const getContentTypeFromPublishedContent = (
	type: string,
	subType: string | null,
): ContentType | null => {
	// CNS-26518: slides may be returned by AGG as a top-level `'slide'` content
	// type (modern data shape used after publishing slides to Confluence) or as
	// a `'whiteboard'` with `subType === 'slide'` (legacy shape). Normalise both
	// here so the slides icon never disappears from the chat preview card.
	if (type === 'slide') {
		return ContentType.slides;
	}
	if (type === 'whiteboard') {
		return subType === 'slide' ? ContentType.slides : ContentType.whiteboard;
	}
	if (type === 'page') {
		return subType === 'live' ? ContentType.liveDoc : ContentType.page;
	}
	if (type === 'database') {
		return ContentType.database;
	}
	return null;
};
